import React from "react";
import "./Main.css"
import { Navbar } from "./Navbar/Navbar";
import { Home } from "./Home/Home";
import { About } from "./About/About";
import { Skills } from "./Skills/Skills";
import { Project } from "./Projects/Project";
import { Contact } from "./Contact/Contact";
import LocomotiveScroll from 'locomotive-scroll';

export const Main = () => {

    React.useEffect(() => {
        // eslint-disable-next-line
        const scroll = new LocomotiveScroll({
            el: document.querySelector('[data-scroll-container]'),
            smooth: true
        });
    },[])



    return (
        <>
            <Navbar />
        <div className="container" data-scroll-container>
            <Home data-scroll-section id="1" className="child" />
            <About data-scroll-section id="2" className="child"/>
            <Skills data-scroll-section id="3" className="child"/>
            <Project data-scroll-section id="3" className="child"/>
            <Contact data-scroll-section id="4" className="child"/>
        </div>
        </>
    )
}